import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Stack, TextField } from '@mui/material';

import useAuth from '../../auth/useAuth';
import { applyServerErrors, getErrorMessage } from '../../utils/errorHandler';

const schema = yup.object({
  name: yup.string().required('El nombre es obligatorio'),
  email: yup.string().email('Ingresa un correo válido').required('El correo es obligatorio'),
  phone: yup.string().required('El teléfono es obligatorio'),
  password: yup.string().min(8, 'Mínimo 8 caracteres').required('La contraseña es obligatoria'),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref('password')], 'Las contraseñas no coinciden')
    .required('Confirma tu contraseña'),
});

export default function RegisterForm() {
  const { register: registerUser } = useAuth();
  const navigate = useNavigate();
  const [formError, setFormError] = useState('');

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: { name: '', email: '', phone: '', password: '', password_confirmation: '' },
  });

  const onSubmit = async (data) => {
    setFormError('');
    try {
      await registerUser(data);
      navigate('/', { replace: true });
    } catch (error) {
      const handled = applyServerErrors(error, setError);
      if (!handled) {
        setFormError(getErrorMessage(error, 'No se pudo completar el registro.'));
      }
    }
  };

  return (
    <Stack component="form" spacing={3} onSubmit={handleSubmit(onSubmit)} noValidate>
      {formError && <Alert severity="error">{formError}</Alert>}

      <TextField
        label="Nombre completo"
        error={Boolean(errors.name)}
        helperText={errors.name?.message}
        {...register('name')}
      />
      <TextField
        label="Correo electrónico"
        type="email"
        autoComplete="email"
        error={Boolean(errors.email)}
        helperText={errors.email?.message}
        {...register('email')}
      />
      <TextField
        label="Teléfono"
        error={Boolean(errors.phone)}
        helperText={errors.phone?.message}
        {...register('phone')}
      />
      <TextField
        label="Contraseña"
        type="password"
        autoComplete="new-password"
        error={Boolean(errors.password)}
        helperText={errors.password?.message}
        {...register('password')}
      />
      <TextField
        label="Confirmar contraseña"
        type="password"
        autoComplete="new-password"
        error={Boolean(errors.password_confirmation)}
        helperText={errors.password_confirmation?.message}
        {...register('password_confirmation')}
      />

      <Button type="submit" variant="contained" size="large" disabled={isSubmitting}>
        {isSubmitting ? 'Creando cuenta...' : 'Crear cuenta'}
      </Button>
    </Stack>
  );
}
